module.exports = __webpack_public_path__ + "static/img/wechartLaihua.9a3f8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/wechartLaihua.jpg
// module id = p8X2
// module chunks = 16